export const alertConstants = {
  SUCCESS: "ALERT_SUCCESS",
  ERROR: "ALERT_ERROR",
  CLEAR: "ALERT_CLEAR",
  BOOM: "ALERT_BOOM",
  ALERT_SHOW: "ALERT_SHOW"
};
